<div class="w-full flex gap-2 pb-2 border-b border-gray-300 font-bold text-xl items-center">
    <h4 (click)="navigate(urls[0].path)" class="no-active">
        {{ urls[0].nome }}
    </h4>

    <i class="fa fa-angle-right font-bold"></i>

    <h4>{{ urls[1]?.nome || "" }}</h4>

    <ng-content></ng-content>
</div>
